import React from 'react';
import styled from 'styled-components';

export const SwapsOptionButton = ({ swapType }: SwapsOptionButtonTypes) => {
  return (
    <ButtonWrapper>
      <ButtonContent>{swapType}</ButtonContent>
    </ButtonWrapper>
  );
};

export default SwapsOptionButton;

const ButtonWrapper = styled.div`
  display: flex;
  height: 52px;
  width: 100%;
  align-items: center;
`;

const ButtonContent = styled.div`
  margin-left: 88px;
  color: #000;
`;

type SwapsOptionButtonTypes = {
  swapType: string;
};
